export const getAllNotes = (state) => state.notes.allNotes;
export const getNoteToEdit = (state) => state.notes.noteToEdit;